/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminportal1Inputs */

const en_adminportal1 = /** @type {(inputs: Adminportal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Portal`)
};

const de_adminportal1 = /** @type {(inputs: Adminportal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Portal`)
};

/**
* | output |
* | --- |
* | "Admin Portal" |
*
* @param {Adminportal1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminportal1 = /** @type {((inputs?: Adminportal1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminportal1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminportal1(inputs)
	return de_adminportal1(inputs)
});
export { adminportal1 as "adminPortal" }